import { render, staticRenderFns } from "./ForgotLogin.vue?vue&type=template&id=37731f28&scoped=true&"
import script from "./ForgotLogin.vue?vue&type=script&lang=js&"
export * from "./ForgotLogin.vue?vue&type=script&lang=js&"
import style0 from "./ForgotLogin.vue?vue&type=style&index=0&id=37731f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37731f28",
  null
  
)

export default component.exports